exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dataTour[data-v-f9862d92]{display:grid;width:100%;grid-template-columns:30% auto}.dataTour div[data-v-f9862d92]{padding:10px;border-bottom:1px solid rgba(0,0,0,.12)}", ""]);

// exports
